import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import SignIn from '@/views/SignIn.vue'
import Challenge from '@/views/Challenge.vue'
import User from '@/views/User.vue'
import Code from '@/views/Code.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "user" */ '@/views/Account.vue'),
  },
  {
    path: '/my-challenges',
    name: 'MyChallenges',
    component: () => import(/* webpackChunkName: "user" */ '@/views/MyChallenges.vue'),
  },
  {
    path: '/my-codes',
    name: 'MyCodes',
    component: () => import(/* webpackChunkName: "user" */ '@/views/MyCodes.vue'),
  },
  {
    path: '/star-challenges',
    name: 'StarChallenges',
    component: () => import(/* webpackChunkName: "user" */ '@/views/StarChallenges.vue'),
  },
  {
    path: '/star-codes',
    name: 'StarCodes',
    component: () => import(/* webpackChunkName: "user" */ '@/views/StarCodes.vue'),
  },
  {
    path: '/new/challenge',
    name: 'ChallengeNew',
    component: () => import(/* webpackChunkName: "user" */ '@/views/ChallengeNew.vue'),
  },
  {
    path: '/challenge/:challenge_name/edit',
    name: 'ChallengeEdit',
    component: () => import(/* webpackChunkName: "user" */ '@/views/ChallengeEdit.vue'),
  },
  {
    path: '/challenge/:challenge_name',
    name: 'Challenge',
    component: Challenge
  },
  {
    path: '/user/:user_name/code/:code_id',
    name: 'Code',
    component: Code
  },
  {
    path: '/user/:user_name',
    name: 'User',
    component: User
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  },
  {
    path: '/tos',
    name: 'ToS',
    component: () => import(/* webpackChunkName: "tos" */ '@/views/ToS.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//router.beforeEach((to, from, next) => {
//  console.log("router.beforeEach");
//  var user = currentUser;
//  console.log("user.displayName = " + user.displayName);
//  if (to.name !== 'Account' && user.authenticated && user.displayName === null) next({ name: 'Account' });
//  else next();
//})

export default router
